
import { useState, useEffect } from 'react'
import { useUpdateObjectMutation, UpdateObjectInstanceCommand } from '../../services/objects'
import { toaster } from 'baseui/toast';
import { LabelMedium, LabelXSmall, ParagraphMedium, ParagraphXSmall } from 'baseui/typography';
import { HttpStatusCodesToString } from '../../services/types';
function useSetObjectValue(objectId: string, resourceGroupId: string, propertyName: string, initialValue: any, delay: number = 3000): any {

  const [value, setValue] = useState(initialValue);
  const [updateClass, setValueResult] = useUpdateObjectMutation()
  const [updateWaiter, setUpdateWaiter] = useState<any>()

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    //console.log("SetvalueResult Error changed",setValueResult)
    if (setValueResult.isError) {
      const err: any = setValueResult.error;
      const httpstatus = err.originalStatus ?? err.status;
      const errMsg = err?.data?.errorMessage ?? err?.data?.message ?? "";
      toaster.negative(
        <>
          <LabelMedium color='white'>Eror write value </LabelMedium>
          <ParagraphMedium color='white' margin={0}>{errMsg}</ParagraphMedium>
          <ParagraphXSmall color='white' margin={0}>{HttpStatusCodesToString(httpstatus)}</ParagraphXSmall>
        </>, {
        autoHideDuration: 7000, overrides: {
          InnerContainer: {
            style: { width: "100%" }
          }
        }
      })
    }
  }, [setValueResult]);


  function mySetValue(newvalue: number) {
    // update state
    setValue(newvalue);
    // clear old waiter if multiple calls occur
    if (updateWaiter) {
      clearTimeout(updateWaiter);
      setUpdateWaiter(undefined);
    }
    setUpdateWaiter(setTimeout(
      () => { writeValueToBackend(propertyName, newvalue) }
      , delay));
  }

  function writeValueToBackend(propertyName: string, value: any) {
    console.log("----->> '" + objectId + "' send value to backend '" + propertyName + "=" + value + "'")
    const cmd: UpdateObjectInstanceCommand = {
      objectId: objectId,
      resourceGroupid: resourceGroupId,
      properties: [
        {
          key: propertyName,
          value: value,
        }
      ]
    };
    updateClass(cmd);
  }

  function sendNow(sendValue: any) {
    // update state
    setValue(sendValue);
    if (updateWaiter) {
      clearTimeout(updateWaiter);
      setUpdateWaiter(undefined);
    }
    writeValueToBackend(propertyName, sendValue);

  }
  return [value, mySetValue, setValueResult, sendNow];
}

export default useSetObjectValue


